import PropTypes from 'prop-types';
import React, { useEffect, useMemo, useState, useCallback } from 'react';
import Sticky from 'react-stickynode';
const StickyNode = (props)=>{
    /**
	 * See https://github.com/yahoo/react-stickynode for usage
	 */ const { children, innerZ = 100000, enabled = true, closeable = false, ...other } = props;
    const [closed, setClosed] = useState({});
    const onClose = useCallback((key)=>{
        setClosed((old)=>({
                ...old,
                [key]: true
            }));
    }, []);
    const closableChildren = useMemo(()=>{
        return React.Children.toArray(children).map((child, i)=>{
            return /*#__PURE__*/ React.cloneElement(child, {
                onClose: ()=>{
                    onClose(i);
                },
                key: child.key || i
            });
        });
    }, [
        children,
        onClose
    ]);
    useEffect(()=>setClosed({}), []);
    const stickyProps = {
        enabled,
        innerZ,
        ...other
    };
    return closeable ? /*#__PURE__*/ React.createElement(Sticky, stickyProps, React.Children.toArray(closableChildren).map((child, i)=>{
        if (!closed[i]) {
            return child;
        }
        return null;
    })) : /*#__PURE__*/ React.createElement(Sticky, stickyProps, children);
};
StickyNode.propTypes = {
    /**
	 * Sticky children
	 */ children: PropTypes.node,
    /**
	 * closeable is enabled, onClose handler is passed to children
	 */ closeable: PropTypes.bool,
    /**
	 * sticky is enabled
	 */ enabled: PropTypes.bool,
    /**
	 * z-index value
	 */ innerZ: PropTypes.number
};
export default StickyNode;
